import { makeStyles } from '@material-ui/core/styles';

const useStyles = makeStyles(theme => ({
  inputRow: {
    margin: theme.spacing(1, 0),
  },
  tableWrapper: {
    maxWidth: 'none',
  },
  table: {
    tableLayout: 'fixed',
  },
}));

export default useStyles;
